import React from "react";
import "./App.css";
import DrinksList from "./DrinksList/DrinksList";
import PrismaticBurst from "./PrismaticBurst";

function App() {
  return (
    <div className="App">
      {/* <PrismaticBurst
        animationType="rotate3d"
        intensity={2}
        speed={0.5}
        distort={1.0}
        paused={false}
        offset={{ x: 0, y: 0 }}
        hoverDampness={0.25}
        rayCount={24}
        mixBlendMode="lighten"
        colors={["#ff007a", "#4d3dff", "#ffffff"]}
      /> */}
      <DrinksList />
    </div>
  );
}

export default App;
